import styles from './index.module.scss';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import React, { useState } from 'react';
import { ArrowRightIcon } from '@navi/web-ui/lib/icons';
import { AddressCardFeedbackProps } from './interfaces';
import dayjs from 'dayjs';
import { getFeedbackColors } from './utils';
import { DateFormat } from '@cp/src/utils/DateHelper';
import ViewAllFeedbacksDrawer from './Feedbacks/ViewAllFeedbacksDrawer';
import cx from 'classnames';

const AddressCardFeedback: React.FC<AddressCardFeedbackProps> = props => {
  const { latestFeedback, addressLine, relatedLocationIds } = props;
  const {
    latestFeedbackTimestamp,
    promiseToPayDate,
    feedbackPresent,
    latestFeedbackStatus,
    feedbackColourCode
  } = latestFeedback || {};

  const [showAllFeedbacksDrawer, setShowAllFeedbacksDrawer] = useState(false);
  const handleOpenAllFeedbacksDrawerClick = () => {
    setShowAllFeedbacksDrawer(!showAllFeedbacksDrawer);
  };

  return (
    <>
      <div className={cx(styles.body, 'rr-block')}>
        <div className="flex gap-1">
          <Typography variant="h6" color="var(--grayscale-content-2)">
            Last feedback
          </Typography>
          <Typography variant="p5" color="var(--grayscale-content-3)">
            {latestFeedbackTimestamp &&
              `(${dayjs(latestFeedbackTimestamp).format(
                DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME
              )})`}
          </Typography>
        </div>

        <Typography
          variant="h5"
          color={getFeedbackColors(latestFeedbackStatus, feedbackColourCode)}
        >
          <div className="flex items-center">
            <div className="truncate w-0 min-w-[90%]">
              {latestFeedbackStatus ? latestFeedbackStatus : 'Unvisited Address'}
              {promiseToPayDate &&
                ` on ${dayjs(promiseToPayDate).format(DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME)}`}
            </div>
          </div>
        </Typography>
        <Button
          variant="text"
          onClick={handleOpenAllFeedbacksDrawerClick}
          disabled={!feedbackPresent}
          endAdornment={<ArrowRightIcon color="var(--navi-color-blue-base)" />}
          className="justify-start mt-1"
        >
          <Typography variant="h6" color="var(--navi-color-blue-base)">
            View old feedbacks
          </Typography>
        </Button>
      </div>
      <ViewAllFeedbacksDrawer
        isDrawerOpen={showAllFeedbacksDrawer}
        onClose={handleOpenAllFeedbacksDrawerClick}
        addressLine={addressLine}
        relatedLocationIds={relatedLocationIds}
      />
    </>
  );
};

export default AddressCardFeedback;
